/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LoaderFunction, MetaFunction, useLoaderData, useSearchParams } from "react-router";
import LiveDataCard from "~/components/home-screen/LiveDataCard";
import BreadCrubComponent from "~/components/shared-components/BreadCrubComponent";
import YoutubeVideoPlayer from "~/components/shared-components/YoutubeVideoPlayer";
import { useFontStyle } from "~/hook/useFontStyle";
import { useLanguageParams } from "~/hook/useLanguageParams";
import useLocale from "~/hook/useLocale";
import useStopCurrentRunningVideoAudio from "~/hook/useStopCurrentRunningVideoAudio";
import { LiveData } from "~/interface/home/home";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { removeAudioPlayerKeyFromSession } from "~/lib/helperFuncation/sessionStorageService";
import { getYoutubeVideoThumbnail } from "~/lib/helperFuncation/youtubeThumbnails";
import { changeIsAudioPlayState, changeIsPlayingState } from "~/lib/store/slice/audioSlice";
import { setCurrentVideo, setCurrentVideoId, setCurrentVideoPosition, setPipMode, setVideoQueue } from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_URL, LANG, LIVE_TV } from "~/utils/constant";
import { homeRouteString } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";
import { ApiService } from "~/utils/service";

interface liveStreamLoaderdata {
  selectedMedia: string;
  selectedType: string;
  liveDataArray: LiveData[];
  selectedTV: LiveData;
  title: string;
  metaTitle: string;
  metaDescription: string;
}

interface MoreLiveDataCard {
  data: LiveData[];
  selectedTab: string;
  title: string;
  selectedMedia: string;
  handleOnTVClick: (type: string) => void;
}

const metaData = {
  swaminarayan_tv: {
    metaTitle: {
      en: "Watch Live Swaminarayan TV | 24/7 Devotional Live Stream | SwaminarayanBhagwan.org",
      gu: "સ્વામિનારાયણ ટીવી લાઇવ જુઓ | ૨૪/૭ ભક્તિ સ્ટ્રીમ | SwaminarayanBhagwan.org",
    },
    metaDescription: {
      en: "Watch Swaminarayan TV live online — 24/7 devotional streaming from Shree Swaminarayan Temple, Kundaldham. Enjoy live Katha, Kirtan, Dhun, Satsang, and spiritual programs. Stream on TV & Radio anytime.",
      gu: "સ્વામિનારાયણ ટીવી ઓનલાઈન ૨૪/૭ લાઇવ જુઓ. શ્રી સ્વામિનારાયણ મંદિર, કુંડળધામ દ્વારા કથા, કીર્તન, ધૂન, સત્સંગ અને આધ્યાત્મિક કાર્યક્રમો ટીવી અને રેડિયો પર ઉપલબ્ધ.",
    },
  },
  katha_tv: {
    metaTitle: {
      en: "Watch Live Swaminarayan Katha TV | Daily Spiritual Discourses | SwaminarayanBhagwan.org",
      gu: "સ્વામિનારાયણ કથા ટીવી લાઇવ | દૈનિક ધાર્મિક પ્રવચન | SwaminarayanBhagwan.org",
    },
    metaDescription: {
      en: "Watch Live Swaminarayan Katha TV — stream daily morning Katha, Granth Katha, Ravi Sabha, Kirtan Vivechan, and spiritual discourses from Shree Swaminarayan Temple, Kundaldham. Available live on TV & Radio.",
      gu: "સ્વામિનારાયણ કથા ટીવી ઓનલાઈન લાઇવ જુઓ. રોજ સવારની કથા, ગ્રંથ કથા, રવિ સભા, કીર્તન વિવેચન અને ધાર્મિક પ્રવચનો શ્રી સ્વામિનારાયણ મંદિર, કુંડળધામ દ્વારા ટીવી અને રેડિયો પર ઉપલબ્ધ.",
    },
  },
  kirtan_tv: {
    metaTitle: {
      en: "Watch Live Swaminarayan Kirtan TV | Bhakti Kirtan & Devotional Songs | SwaminarayanBhagwan.org",
      gu: "સ્વામિનારાયણ કીર્તન ટીવી લાઇવ | ભક્તિ કીર્તન અને ભજન | SwaminarayanBhagwan.org",
    },
    metaDescription: {
      en: "Stream Live Swaminarayan Kirtan TV — watch devotional Kirtans, bhajan, and spiritual songs from Shree Swaminarayan Temple, Kundaldham. Experience the divine sounds of Swaminarayan Sampraday live on TV & Radio.",
      gu: "સ્વામિનારાયણ કીર્તન ટીવી ઓનલાઈન લાઇવ જુઓ. શ્રી સ્વામિનારાયણ મંદિર, કુંડળધામ દ્વારા ભક્તિ કીર્તન, ભજન અને ધાર્મિક સ્તોત્રો ટીવી અને રેડિયો પર ઉપલબ્ધ. સ્વામિનારાયણ સંપ્રદાયના દિવ્ય સ્વરો સાંભળો.",
    },
  },
  dhun_tv: {
    metaTitle: {
      en: "Watch Live Swaminarayan Dhun TV | Continuous Swaminarayan Dhun & Chanting | SwaminarayanBhagwan.org",
      gu: "સ્વામિનારાયણ ધૂન ટીવી લાઇવ | સ્વામિનારાયણ ધૂન અને ભજન | SwaminarayanBhagwan.org",
    },
    metaDescription: {
      en: "Stream Live Swaminarayan Dhun TV — experience continuous Swaminarayan Dhun, devotional chanting, and spiritual music from Shree Swaminarayan Temple, Kundaldham. Listen live on TV & Radio for peace and meditation.",
      gu: "સ્વામિનારાયણ ધૂન ટીવી ઓનલાઈન લાઇવ જુઓ. શ્રી સ્વામિનારાયણ મંદિર, કુંડળધામ દ્વારા સ્વામિનારાયણ ધૂન, ભજન અને આધ્યાત્મિક સ્વર ટીવી અને રેડિયો પર ઉપલબ્ધ. ધ્યાન અને શાંતિ માટે ચોવીસ કલાક ઉપલબ્ધ.",
    },
  },
};

export const loader: LoaderFunction = async ({ params, request }) => {
  const { lang, slug } = params;
  const url = new URL(request.url);
  const selectedLiveTv = slug;

  const apiService = new ApiService(lang || LANG.english);
  const liveDataResponse = await apiService.getLiveData();

  const selectedMedia = selectedLiveTv ?? null;
  const selectedType = selectedLiveTv ? LIVE_TV : null;

  const selectedTvKey = selectedMedia?.replace(/-/g, "_");

  const selectedTV = liveDataResponse.find((item: LiveData) => item.type === selectedTvKey);

  const title = selectedTV?.tv_title || (lang === LANG.english ? "Live" : "લાઇવ");

  // Use metaData for selected TV type if available, otherwise use default
  const defaultMetaTitle =
    lang === LANG.english
      ? `Watch Live Swaminarayan TV, Katha, Kirtan & Dhun | Live Streaming | 24/7 Live Radio | SwaminarayanBhagwan.org`
      : "સ્વામિનારાયણ ટીવી, કથા, કીર્તન અને ધૂન લાઇવ જુઓ | સ્વામિનારાયણ લાઇવ સ્ટ્રીમિંગ | 24/7 લાઇવ રેડિયો | SwaminarayanBhagwan.org";
  const defaultMetaDescription =
    lang === LANG.english
      ? `Watch Live Swaminarayan TV channels including Katha TV, Kirtan TV, and Dhun TV. Stream live religious discourses, devotional songs, and spiritual content from Shree Swaminarayan Temple, Kundaldham. Available 24/7 on TV & Radio.`
      : "સ્વામિનારાયણ ટીવી, કથા ટીવી, કીર્તન ટીવી અને ધૂન ટીવી ૨૪/૭ લાઇવ જુઓ. શ્રી સ્વામિનારાયણ મંદિર, કુંડળધામ દ્વારા ધાર્મિક પ્રવચન, ભક્તિ ગીતો અને આધ્યાત્મિક સામગ્રી ટીવી અને રેડિયો પર ઉપલબ્ધ.";

  const metaTitle =
    selectedTvKey && metaData[selectedTvKey as keyof typeof metaData]
      ? metaData[selectedTvKey as keyof typeof metaData].metaTitle[lang === LANG.english ? "en" : "gu"]
      : defaultMetaTitle;

  const metaDescription =
    selectedTvKey && metaData[selectedTvKey as keyof typeof metaData]
      ? metaData[selectedTvKey as keyof typeof metaData].metaDescription[lang === LANG.english ? "en" : "gu"]
      : defaultMetaDescription;

  return {
    title,
    selectedMedia,
    selectedType,
    liveDataArray: liveDataResponse,
    selectedTV,
    metaTitle,
    metaDescription,
  };
};

export const meta: MetaFunction = ({ location, params, data }) => {
  const pathname = location?.pathname || "/";
  const lang = params.lang || "en";
  const meta = getPageMeta("liveTvRadio", lang);
  const tvdata = data as liveStreamLoaderdata;

  return metaService({
    title: tvdata?.metaTitle || meta.metaTitle,
    description: tvdata?.metaDescription || meta.metaDescription,
    ogTitle: tvdata?.metaTitle || meta.ogTitle,
    ogDescription: tvdata?.metaDescription || meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage ?? FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth ?? "1200",
    ogHeight: meta.ogImageHeight ?? "630",
    canonicalLink: `${pathname}`,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

export const handle = {
  breadcrumb: (match: any) => {
    const lang = match.params.lang;
    const slug = match.params.slug;

    return (
      <BreadCrubComponent
        breadCrub={[
          {
            path: homeRouteString(lang).path,
            title: homeRouteString(lang).home,
          },
          ...(slug
            ? [
                {
                  path: `/live`,
                  title: lang === LANG.english ? "Live" : "લાઇવ",
                },
              ]
            : []),
        ]}
      />
    );
  },
  breadcrumbSchema: (match: any) => {
    const slug = match.params.slug;
    return [
      { name: "Home", path: "/" },
      { name: "Live", path: "/live" },
      ...(slug ? [{ name: match.data?.title || slug, path: `/live/${slug}` }] : []),
    ];
  },
};

function liveStream() {
  const { liveDataArray, selectedType, selectedMedia, selectedTV } = useLoaderData<liveStreamLoaderdata>();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isVideoPlay } = useAppSelector((state) => state.youtubeVideo);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { navigate } = useLocale();

  const { playCurrentVideo } = useStopCurrentRunningVideoAudio();

  const handleOnTVClick = (type: string) => {
    navigate(`/live/${type.split("_").join("-")}`);
  };

  useEffect(() => {
    const videoQueue = liveDataArray?.map((item) => {
      return {
        id: item?.id,
        videoId: item?.yt_id,
        from: `/live/${item?.type}`,
        name: item?.tv_title || "",
        duration: null,
        thumbnailUrl: getYoutubeVideoThumbnail(item?.yt_id, "medium") || FALLBACK_IMAGE_URL,
      };
    });

    if (selectedTV) {
      const currentVideo = {
        id: selectedTV.id,
        videoId: selectedTV.yt_id,
        from: `/live/${selectedMedia}`,
        name: selectedTV.tv_title || "",
        duration: null,
        thumbnailUrl: getYoutubeVideoThumbnail(selectedTV.yt_id, "medium") || FALLBACK_IMAGE_URL,
      };

      if (videoQueue.length > 0) {
        dispatch(setVideoQueue(videoQueue));
      }

      dispatch(changeIsAudioPlayState(false));
      dispatch(changeIsPlayingState(false));
      removeAudioPlayerKeyFromSession();
      dispatch(setCurrentVideo(currentVideo));

      dispatch(setCurrentVideoId(selectedTV.yt_id));
      playCurrentVideo(selectedTV?.yt_id);
      dispatch(setCurrentVideoPosition(0));
    } else {
      const newParamas = new URLSearchParams();
      newParamas.delete("tv");
      setSearchParams(newParamas, { replace: true });
    }
  }, [selectedTV]);

  useEffect(() => {
    if (!isVideoPlay) {
      dispatch(setPipMode(false));
    }
  }, [isVideoPlay]);

  return (
    <div className="w-full flex flex-col justify-start items-center gap-8 overflow-x-hidden">
      {selectedType === LIVE_TV && selectedTV && (
        <div className="w-full flex flex-col justify-start items-center pb-[16px] gap-3">
          <div className="max-md:w-full md:h-[500px] aspect-[16/9] bg-gray-300 rounded-lg overflow-hidden">
            <YoutubeVideoPlayer
              handlePlayVideo={() => playCurrentVideo(selectedTV?.yt_id)}
              videoId={selectedTV?.yt_id}
              onReady={() => {
                dispatch(setPipMode(true));
              }}
            />
          </div>
        </div>
      )}

      <MoreLiveDataCard
        data={liveDataArray}
        selectedTab={selectedType === LIVE_TV ? LIVE_TV : LIVE_TV}
        title={t("home.liveTvRadio")}
        selectedMedia={selectedMedia}
        handleOnTVClick={handleOnTVClick}
      />
    </div>
  );
}

const MoreLiveDataCard = ({ data, selectedTab, title, selectedMedia, handleOnTVClick }: MoreLiveDataCard) => {
  const { medium } = useFontStyle();
  const lang = useLanguageParams();
  const isGujarati = lang === LANG.gujarati;

  return (
    <div className="!w-dvw flex flex-col justify-start items-center bg-cardBgColor    cursor-pointer">
      <div className="body-container flex flex-col gap-8 py-20">
        <div className="w-full flex justify-center px-3 items-center">
          <span className={cn(isGujarati ? "home-page-heading-mar-guj" : "home-page-heading", medium)}>{title}</span>
        </div>
        <div className={cn("grid grid-cols-1 sm:grid-cols-2 gap-5 px-3 w-full ", data?.length > 4 ? "md:grid-cols-5" : "md:grid-cols-4")}>
          {data.map((data) => {
            return (
              <React.Fragment key={data.id}>
                <LiveDataCard data={data} selectedTab={selectedTab} selectedMedia={selectedMedia} handleOnTVClick={handleOnTVClick} />
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default liveStream;
